<script>
import tableData from '@src/data/print-table.json'
import { agreements } from '@src/data/agreement.json'

export default {
  metaInfo: {
    title: 'Print Checkin',
    meta: [{ name: 'description', content: 'Print Checkin' }],
  },

  props: {
    checkIn: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tableData,
      agreements,
    }
  },

  methods: {
    print() {
      window.print()
      window.close()
    }
  },
}
</script>

<template>
<div class="pr__book">
  <div class="pr__page">
    <div class="pr__subpage">
      <h3 class="pr__mb-2">Registration Form</h3>
      <h4 class="pr__mb-2">Reservation No: {{ checkIn.hotelConfirmation }}</h4>
      <table v-for="table in Object.keys(tableData)" :key="table" class="pr__table pr__mb-4">
        <thead>
          <tr>
            <th v-for="col in tableData[table].col" :key="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tableItems, index) in tableData[table].items" :key="index">
            <td v-for="item in tableItems" :key="item.key">
              <span class="pr__uppercase pr__mb-2">{{ item.label }}</span>
              <span>{{ checkIn[item.key] }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="pr__page">
    <div class="pr__subpage">

      <table class="pr__table pr__mb-4">
        <tbody>
          <tr>
            <td colspan="2">
              <span class="pr__mb-2">By signing below, I acknowledge that:</span>
              <ul>
                <li v-for="agreement in agreements" :key="agreement.id" class="pr__mb-2">
                  {{ agreement.text }}
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td colspan="1">
              <span class="pr__uppercase pr__mb-2">Guest Signature</span>
              <span class="pr__img-wrapper">
                <img :src="checkIn.signature" alt="guest signature">
              </span>
            </td>
            <td colspan="1">
              <span class="pr__uppercase pr__mb-2">Guest Relation Officer</span>
              <span>{{ checkIn.officer }}</span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>

  <div class="pr__page">
    <div class="pr__subpage">
      <table class="pr__table pr__mb-4">
        <tbody>
          <tr>
            <td>
              <span class="pr__uppercase pr__mb-2">Passport/ID Photo</span>
              <span>
                <img :src="checkIn.identificationPhoto" alt="passport/id photo">
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-for="(accompany, index) in checkIn.accompanying" :key="index" class="pr__page">
    <div class="pr__subpage">
      <table class="pr__table pr__mb-4">
        <tbody>
          <tr >
            <td>
              <span class="pr__uppercase pr__mb-2">Accompany {{ index + 1 }}</span>
              <span class="pr__uppercase pr__mb-2">{{ accompany.name }}</span>
              <span class="pr__img-wrapper">
                <img :src="accompany.src" alt="passport/id photo">
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <VBtn
    fab fixed dark right bottom
    class="pr__hide-on-print"
    style="background-color: #c5a46d;"
    @click.prevent="print"
  >
      <VIcon small>
        print
      </VIcon>
    </VBtn>
</div>
</template>

<style lang="scss">
* {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
}

body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #FAFAFA;
}

@page {
    size: A4;
    margin: 0;
}

@page {
    size: A4;
    margin: 0;
}

@media print {
    html, body {
        width: 210mm;
        height: 297mm;
    }
    .pr__hide-on-print {
      display: none;
    }
}

.pr__ {
  &mb- {
    &2 {
      margin-bottom: 0.5rem;
    }
    &4 {
      margin-bottom: 1rem;
    }
  }

  &uppercase {
    text-transform: uppercase;
  }

  &page {
    width: 210mm;
    min-height: 297mm;
    padding: 20mm;
    margin: 10mm auto;
    border: 1px #D3D3D3 solid;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

    @media print {
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      min-height: initial;
      box-shadow: initial;
      background: initial;
      page-break-after: always;
    }
  }

  &subpage {
    padding: 1cm;
    height: 257mm;
  }

  &table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th {
      width: 33.333333%;
    }

    td {
      border: 1px solid black;
      padding: .5rem 1rem;
      vertical-align: top;
    }

    span {
      display: block;
    }

    img {
      width: 100%;
    }
  }

  &img-wrapper {
    max-height: 220mm;
    overflow: hidden;
  }
}
</style>
